import LoadableComponent from '@loadable/component';
import React from 'react';
import { Redirect, Route, HashRouter as Router, Switch } from 'react-router-dom';

const App = LoadableComponent(() => import('./App'));
App.preload();
const Login = LoadableComponent(() => import('./components/pages/Login'));
Login.preload();
const Register = LoadableComponent(() => import('./components/pages/Register'));
Register.preload();
const Forgot = LoadableComponent(() => import('./components/pages/Forgot'));
Forgot.preload();
const NotFound = LoadableComponent(() => import('./currency_common/src/components/tools/NotFound'));
NotFound.preload();
const ModifyPassword = LoadableComponent(() => import('./components/pages/ModifyPassword'));
ModifyPassword.preload();
const ModifyPasswordSucess = LoadableComponent(
    () => import('./components/pages/ModifyPasswordSuccess'),
);
ModifyPasswordSucess.preload();

export default function () {
    return (
        <Router>
            <Switch>
                <Route exact path="/" render={() => <Redirect to="/app/dashboard/index" push />} />
                <Route path="/app" component={App} />
                <Route path="/404" component={NotFound} />
                <Route path="/login" component={Login} />
                <Route path="/register" component={Register} />
                <Route path="/forgot" component={Forgot} />
                <Route path="/modifyPassword" component={ModifyPassword} />
                <Route path="/modifyPasswordSuccess" component={ModifyPasswordSucess} />
                <Route component={NotFound} />
            </Switch>
        </Router>
    );
}
